import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { useProductStore } from "./ProductStore";

const hotelInformation = {
	1: {
		address: {
			address_name: "",
			address_line1: "DoubleTree by Hilton Leeds City Centre",
			address_line2: "Granary Wharf, 2 Wharf Approach",
			address_town: "Leeds",
			address_county: "West Yorkshire",
			address_postcode: "LS1 4BR",
			address_country: "United Kingdom",
			address_lat: 53.79363,
			address_long: -1.54937,
		},
	},
};

interface HotelState {
	hotelFlow: string | null;
	hotelId: number | null;
	name: string | null;
	date: string | null;
	hotelInfo: any;
	setHotelInformation: (date: string, hotelId: number, name: string) => void;
	setHotelFlow: (hotelFlow: string) => void;
}

const useHotelStore = create<HotelState>()(
	persist(
		devtools((set, get) => ({
			hotelFlow: null,
			hotelId: null,
			name: null,
			date: null,
			hotelInfo: {},
			setHotelInformation: (date, hotelId, name) => {
				let hotelInfo = hotelInformation[hotelId] || {};

				set({
					hotelId,
					name: name,
					date,
					hotelInfo: {
						address: {
							...hotelInfo.address,
							address_name: name,
						},
					},
				});
			},
			setHotelFlow: (hotelFlow) => set({ hotelFlow }),
		})),
		{
			name: "hotel-storage",
		},
	),
);

export { useHotelStore };
